<template>
  <transition name="fade">
    <section role="tabpanel" class="tab-item" v-if="isActive">
      <slot></slot>
    </section>
  </transition>
</template>

<style lang="less">
  @import (reference) '../assets/styles/references';


</style>

<script>
  export default {
    props: {
      name: { required: true },
      selected: { default: false },
      image: { default: false }
    },
    data() {
      return {
        isActive: false,
        height: ''
      }
    },
    mounted() {
      this.isActive = this.selected
    }
  }
</script>



// WEBPACK FOOTER //
// Tab.vue?7b01fdee